/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_DurationInputs */

const en_task_field_duration = /** @type {(inputs: Task_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (days)`)
};

const pt_br2_task_field_duration = /** @type {(inputs: Task_Field_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração (dias)`)
};

/**
* | output |
* | --- |
* | "Duration (days)" |
*
* @param {Task_Field_DurationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_duration = /** @type {((inputs?: Task_Field_DurationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_DurationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_duration(inputs)
	return pt_br2_task_field_duration(inputs)
});